module.exports = __webpack_public_path__ + "images/icon-success-35ee17c89e17cfe0003d62417d94a37d.png";